import clsx from 'clsx';

import styles from './Toggle.module.scss';

export const Toggle = ({
  id,
  label,
  onChange,
  disabled = false,
  checked = true,
  className,
}: {
  id: string;
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  disabled?: boolean;
  className?: string;
}) => {
  return (
    <div className={clsx(styles.base, className)} data-ui="toggle">
      <input
        checked={checked}
        className="sr-only"
        disabled={disabled}
        id={id}
        onChange={onChange}
        type="checkbox"
      />
      <label htmlFor={id}>
        <span className={styles.label} data-ui="toggle-label">
          {label}
        </span>
        <div
          aria-checked={checked}
          className={styles.toggle}
          data-ui="toggle-switch"
          role="switch"
        />
      </label>
    </div>
  );
};
